import { render, staticRenderFns } from "./DeskMobile.vue?vue&type=template&id=9c916612&scoped=true&"
import script from "./DeskMobile.vue?vue&type=script&lang=js&"
export * from "./DeskMobile.vue?vue&type=script&lang=js&"
import style0 from "./DeskMobile.vue?vue&type=style&index=0&id=9c916612&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c916612",
  null
  
)

export default component.exports